import { Fragment } from 'react'
import cx from 'classnames'
import { Row, Col, Card } from 'antd'
import _ from 'lodash'
import { PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { HyperLink } from '../../../../Common/Form'
import { ConnectedListingLink } from '../../../../Common/ListingLink/ListingLink'
import styles from './index.css'

const UpdatedListingsTableCard = props => {
  const {
    proposalType,
    successMap = {},
    listings = [],
    /* 新增以下參數供 BatchUploadImage 共用上傳完成列表使用 */
    proposalTypePrefix = '',
    proposalTypeSuffix = '',
    size,
    className,
    children: customContent,
    batchLink,
    noActions = false
  } = props
  const updatedListings = _.filter(listings, listing => _.get(successMap, listing.id))
  const idsStr = _.flow(
    () => _.map(updatedListings, 'proposal.id'),
    ids => _.join(ids, COMMA)
  )()

  return (
    <>
      <Card className={cx(styles.updateListingTable, className)}>
        <Row
          type='flex'
          align='middle'
          justify='space-between'
          className={styles.batchInfo}
        >
          <Col span={16}>
            <p>
              <span className={styles.highlight}>{proposalTypePrefix}</span>
              提案資訊
              <span className={styles.following}>
                {proposalTypeSuffix}
              </span>
              <span
                className={cx(
                  styles.subTitle,
                  styles.counter
                )}
              >
                {`共 ${size || _.size(updatedListings)} 筆`}
              </span>
            </p>
            <p className={styles.subTitle}>
              (點擊提案編號可檢視提案執行狀態)
            </p>
          </Col>
          <Col span={8}>
            <HyperLink
              target='_blank'
              href={batchLink || `${PROPOSAL_PHASE_TYPE.OVERVIEW}?ids=${idsStr}`}
            >
              批次提案檢視
            </HyperLink>
          </Col>
        </Row>
        { customContent || (
          <Row
            type='flex'
            align='middle'
            justify='space-between'
            gutter={[0, 8]}
          >
            {updatedListings.map(updatedListing => {
              const {
                id: listingId,
                proposal: {
                  id: proposalId
                } = {}
              } = updatedListing
              return (
                <Fragment
                  key={listingId}
                  className={styles.updateListingTable}
                >
                  <Col span={12}>
                    提案編號：
                    <HyperLink
                      target='_blank'
                      href={`/proposal/${proposalType}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?id=${proposalId}`}
                      data-role='proposal-id'
                    >
                      {proposalId}
                    </HyperLink>
                  </Col>
                  <Col span={12}>
                    查看賣場：
                    <ConnectedListingLink targetListingId={listingId}>
                      {listingId}
                    </ConnectedListingLink>
                  </Col>
                </Fragment>
              )
            })}
          </Row>
        )}
      </Card>
      {!noActions && (
        <div className={styles.listingQueryBlock}>
          <HyperLink
            target='_blank'
            href={'/listing/query'}
          >
            繼續修改其他賣場
          </HyperLink>
        </div>
      )}
    </>
  )
}

export default UpdatedListingsTableCard
